'use strict';

function toExtendedJSON() {
  return { $maxKey: 1 };
}

function fromExtendedJSON(BSON) {
  return new BSON.MaxKey();
}

module.exports = {
  toExtendedJSON: toExtendedJSON,
  fromExtendedJSON: fromExtendedJSON
};



// WEBPACK FOOTER //
// ./~/mongodb-extjson/lib/bson/max_key.js